import React, {useMemo, useState} from 'react';


import {AuthenticationContext} from 'src/modules/authentication/authentication-context';
import {OktaAuthenticationEnvironment} from 'src/modules/authentication/okta-provieder';
import {ErrorPage} from 'src/modules/error-page/error-page.components';

import Loading from '@pb/kit-component-loading';

import {useAuthenticationConfig} from './useAuthenticationConfig';

type Props = {
    children: React.ReactElement,
};

export const AuthenticationGateway = ({children}: Props) => {
    const {
        isLoading,
        loadingError,
        data,
    } = useAuthenticationConfig();

    const [isLogoutRequested, requestLogout] = useState(false);

    const value = useMemo(() => ({provider: data, isLogoutRequested, requestLogout}), [data, isLogoutRequested]);

    return (
        <AuthenticationContext.Provider value={value}>
            {isLoading ? <Loading fast={true}/> : null}
            {!!loadingError && <ErrorPage title="Service is temporarily unavailable" subtitle="Please try later"/>}
            {Object.keys(data.config).length ? (
                <OktaAuthenticationEnvironment authProvider={data}>
                    {children}
                </OktaAuthenticationEnvironment>
            ) : null}
        </AuthenticationContext.Provider>
    );
};
